export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9099.428221b9.jpg";